export const RESET = 'EXCMTEAM_LIST_RESET'
export const SET_ITEMS = 'EXCMTEAM_LIST_SET_ITEMS'
export const SET_ERROR = 'EXCMTEAM_LIST_SET_ERROR'
export const SET_VIEW = 'EXCMTEAM_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXCMTEAM_LIST_TOGGLE_LOADING'
